import advertisingActionKeys from './advertisingActionKeys';
import * as advertisingService from './advertisingService';

export const getInitialAgreement = (agreementId, token) => ({
  type: advertisingActionKeys.ADVERTISING_GET_INITIAL_AGREEMENT,
  payload: advertisingService.getAgreement(agreementId, token),
});

export const acceptAgreement = (agreementId, initials, token) => ({
  type: advertisingActionKeys.ADVERTISING_ACCEPT_AGREEMENT,
  payload: advertisingService.acceptAgreement(agreementId, initials, token),
});

export const getOpportunityOwners = (agreementId, token) => ({
  type: advertisingActionKeys.GET_OPPORTUNITY_OWNERS,
  payload: advertisingService.getOpportunityOwners(agreementId, token),
});

export const fetchAgreementsByServiceProviderId = (spId, lastUpdatedate) => ({
  type: advertisingActionKeys.FETCH_AGREEMENTS_BY_SERVICE_PROVIDER_ID,
  payload: advertisingService.fetchAgreementsByServiceProviderId(spId, lastUpdatedate),
});

export default {
  getInitialAgreement,
  acceptAgreement,
  getOpportunityOwners,
  fetchAgreementsByServiceProviderId,
};



// WEBPACK FOOTER //
// ./src/modules/adAgreement/common/advertising-gateway/advertisingActions.js